import { useEffect, useState } from 'react';

import { errorKey, type AuthApi, type PurchaseOrder } from '../auth/api';
import { useI18n } from '../i18n/I18nProvider';
import { Sheet } from '../ui/Sheet';
import './shop.css';

/**
 * 购买记录。
 *
 * 状态**要如实画出来**，尤其是 `paid` —— 那是"钱收了、币没发"。
 * 把它和 `credited` 画成一样的话，玩家不会来问，而那笔账就一直挂着。
 */
export function PurchaseSheet(
  { open, api, token, onClose, money }:
  {
    open: boolean;
    api: AuthApi;
    token: string;
    onClose(): void;
    money(n: number): string;
  },
) {
  const { t, i18n } = useI18n();
  const [items, setItems] = useState<PurchaseOrder[] | null>(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!open) return;
    let alive = true;
    setErr('');
    api.purchases(token)
      .then((r) => { if (alive) setItems(r.items); })
      .catch((e) => { if (alive) setErr(t(errorKey(e))); });
    return () => { alive = false; };
  }, [open, api, token, t]);

  return (
    <Sheet open={open} title={t('shop.history')} onClose={onClose}>
      <div className="stack">
        {items === null && !err && <p className="small dim">{t('action.working')}</p>}
        {items?.length === 0 && <p className="small dim">{t('shop.noHistory')}</p>}

        {items && items.length > 0 && (
          <ul className="shop__list">
            {items.map((o) => (
              <li key={o.orderNo} className="shop__item">
                <div className="spread">
                  {/* 到账多少是玩家关心的那个数；实付在下面一行 */}
                  <span className="num">{money(o.coins)}</span>
                  <span className={`shop__st shop__st--${o.status}`}>
                    {t(`shop.st.${o.status}` as 'shop.st.created')}
                  </span>
                </div>
                <span className="small dim">
                  {money(o.price)} · {o.ts ? i18n.dateTime(o.ts * 1000) : ''}
                </span>
                {/* 订单号：**出问题时客服要的就是它**。用等宽和可选中。 */}
                <span className="small dim num shop__no">{o.orderNo}</span>
              </li>
            ))}
          </ul>
        )}

        {err && <p className="field__err" role="alert">{err}</p>}
      </div>
    </Sheet>
  );
}
